<template>
  <div class="model-navbar navbar">
    <div class="model-navbar__logocontainer">
      <svg
        class="model-navbar__logo"
        xmlns="http://www.w3.org/2000/svg"
        width="969.706"
        height="167.356"
        viewBox="0 0 969.706 167.356"
        style="fill: var(--color-grey-dark)"
      >
        <g>
          <g>
            <path
              d="M0,116.827c0-1.931,1.287-3.218,3.218-3.218H15.126c1.931,0,3.218,.965,3.218,3.218,.965,21.886,11.908,32.828,33.149,32.828,19.31,0,28.965-10.621,28.965-25.747C80.459,84.966,1.609,97.195,1.609,43.448,1.609,19.954,19.954,0,47.954,0c31.541,0,47.311,18.667,48.598,47.311,0,1.931-1.287,3.218-3.218,3.218h-11.908c-1.931,0-3.218-.965-3.218-3.218-.965-17.058-10.621-29.609-29.287-29.609-17.379,0-28.966,10.621-28.966,25.747,0,37.333,78.851,25.104,78.851,80.46,0,23.494-18.667,43.448-47.31,43.448-30.896,0-50.207-19.954-51.494-50.529Z"
            />
            <path
              d="M131.954,160.919V6.437c0-1.931,1.288-3.218,3.218-3.218h11.908c1.931,0,3.218,1.287,3.218,3.218V160.919c0,1.932-1.287,3.219-3.218,3.219h-11.908c-1.931,0-3.218-1.287-3.218-3.219Z"
            />
            <path
              d="M353.06,50.528v110.391c0,1.932-1.287,3.219-3.218,3.219h-11.908c-1.931,0-3.218-1.287-3.218-3.219V50.528c0-19.31-9.977-32.827-27.678-32.827s-27.678,13.518-27.678,32.827v110.391c0,1.932-1.288,3.219-3.219,3.219h-11.908c-1.931,0-3.218-1.287-3.218-3.219V50.528c0-19.31-9.977-32.827-27.678-32.827s-27.678,13.518-27.678,32.827v110.391c0,1.932-1.287,3.219-3.218,3.219h-11.908c-1.931,0-3.218-1.287-3.218-3.219V50.528c0-28.965,18.023-50.528,46.023-50.528,16.735,0,29.931,9.978,37.011,24.138,6.759-14.16,19.954-24.138,36.689-24.138,28,0,46.023,21.563,46.023,50.528Z"
            />
            <path
              d="M385.247,116.827V50.528c0-28.965,19.31-50.528,48.275-50.528,28,0,46.667,19.954,48.276,47.311,0,1.931-1.287,3.218-3.218,3.218h-11.908c-1.931,0-3.218-.965-3.218-3.218-1.288-17.701-12.23-29.609-29.931-29.609-18.667,0-29.931,13.518-29.931,32.827V116.827c0,19.311,11.586,32.828,30.575,32.828,18.023,0,29.287-13.195,30.575-32.828,0-2.253,1.287-3.218,3.218-3.218h11.908c1.931,0,3.219,1.287,3.219,3.218-1.609,29.287-20.598,50.529-48.919,50.529-29.288,0-48.919-21.563-48.919-50.529Z"
            />
            <path
              d="M508.509,160.919V6.437c0-1.931,1.287-3.218,3.218-3.218h11.908c1.931,0,3.219,1.287,3.219,3.218V160.919c0,1.932-1.288,3.219-3.219,3.219h-11.908c-1.931,0-3.218-1.287-3.218-3.219Z"
            />
            <path
              d="M559.359,116.827c0-1.931,1.288-3.218,3.219-3.218h11.908c1.931,0,3.218,.965,3.218,3.218,.966,21.886,11.908,32.828,33.149,32.828,19.311,0,28.966-10.621,28.966-25.747,0-38.942-78.851-26.713-78.851-80.46,0-23.494,18.345-43.448,46.345-43.448,31.54,0,47.311,18.667,48.598,47.311,0,1.931-1.287,3.218-3.218,3.218h-11.908c-1.932,0-3.219-.965-3.219-3.218-.966-17.058-10.621-29.609-29.287-29.609-17.379,0-28.966,10.621-28.966,25.747,0,37.333,78.851,25.104,78.851,80.46,0,23.494-18.667,43.448-47.311,43.448-30.896,0-50.206-19.954-51.494-50.529Z"
            />
            <path
              d="M691.314,160.919V6.437c0-1.931,1.287-3.218,3.218-3.218h11.908c1.931,0,3.219,1.287,3.219,3.218V160.919c0,1.932-1.288,3.219-3.219,3.219h-11.908c-1.931,0-3.218-1.287-3.218-3.219Z"
            />
            <path
              d="M742.487,116.827V50.528c0-28.965,19.633-50.528,49.563-50.528s49.563,21.563,49.563,50.528V116.827c0,28.966-19.633,50.529-49.563,50.529s-49.563-21.563-49.563-50.529Zm80.46,0V50.528c0-19.632-11.586-33.148-30.896-33.148s-30.896,13.517-30.896,33.148V116.827c0,19.633,11.586,33.149,30.896,33.149s30.896-13.517,30.896-33.149Z"
            />
            <path
              d="M873.797,160.919V50.528c0-28.965,19.311-50.528,47.954-50.528s47.954,21.563,47.954,50.528v110.391c0,1.932-1.288,3.219-3.219,3.219h-11.908c-1.931,0-3.218-1.287-3.218-3.219V50.528c0-19.632-11.265-33.148-29.609-33.148s-29.609,13.517-29.609,33.148v110.391c0,1.932-1.287,3.219-3.219,3.219h-11.907c-1.932,0-3.219-1.287-3.219-3.219Z"
            />
          </g>
        </g>
      </svg>
    </div>

    <editor-navigation-modules-list />

    <div class="navbar__group">
      <template v-if="undoAvailableInOpenModule">
        <!-- UNDO & REDO BUTTONS -->
        <button
          ref="undoButton"
          class="button-icon button-icon_small ph-4 model-navbar__button"
          type="button"
          :disabled="!canUndo"
          :title="$t('labels.undo')"
          @click="undo"
          @contextmenu.prevent="undoContextMenuOpen = !undoContextMenuOpen"
        >
          <lucide-icon name="undo" />
        </button>
        <context-menu
          v-if="undoContextMenuOpen"
          id="editor-undomenu"
          x-alignment="right"
          style="right: 1rem; top: calc(3.4rem - 5px)"
          transition="transition-fade"
          :non-closing-elements="undoButton ? [undoButton] : []"
          class="pv-2"
          @close="undoContextMenuOpen = false"
        >
          <button
            :disabled="!canUndo"
            type="button"
            class="context-menu__entry ph-3"
            @click="undoAll()"
          >
            {{ $t("actions.undoAll") }}
          </button>
        </context-menu>

        <button
          ref="redoButton"
          class="button-icon button-icon_small ph-4 model-navbar__button"
          type="button"
          :disabled="!canRedo"
          :title="$t('labels.redo')"
          @click="redo"
          @contextmenu.prevent="redoContextMenuOpen = !redoContextMenuOpen"
        >
          <lucide-icon name="redo" />
        </button>
        <context-menu
          v-if="redoContextMenuOpen"
          id="editor-redomenu"
          x-alignment="right"
          style="right: 1rem; top: calc(3.4rem - 5px)"
          transition="transition-fade"
          :non-closing-elements="redoButton ? [redoButton] : []"
          class="pv-2"
          @close="redoContextMenuOpen = false"
        >
          <button
            :disabled="!canRedo"
            type="button"
            class="context-menu__entry ph-3"
            @click="redoAll()"
          >
            {{ $t("actions.redoAll") }}
          </button>
        </context-menu>
      </template>

      <button
        v-if="canSave || canSaveAs || !isForeignModel"
        ref="saveButton"
        class="button-icon button-icon_small ph-4 model-navbar__button"
        type="button"
        style="position: relative;"
        :title="(canSaveAs && !canSave) ? $t('labels.saveAs') : $t('actions.save')"
        @click="save()"
        @contextmenu="onSaveContextmenu"
      >
        <lucide-icon :name="canSave ? 'save' : (canSaveAs ? 'save-as' : 'save-off')" />

        <transition name="transition-fade">
          <span v-show="(canSave || canSaveAs) && modelChanged" class="model-navbar__changemark"></span>
        </transition>
      </button>

      <context-menu
        v-if="saveContextMenuOpen"
        id="editor-savemenu"
        x-alignment="right"
        style="right: 1rem; top: calc(3.4rem - 5px)"
        transition="transition-fade"
        :non-closing-elements="saveButton ? [saveButton] : []"
        class="pv-2"
        @close="saveContextMenuOpen = false"
      >
        <button
          :disabled="!canSaveAs"
          type="button"
          class="context-menu__entry ph-3"
          @click="saveAs()"
        >
          {{ $t("labels.saveAs") }}
          <span class="model-navbar__shortcut">
            {{ cmdButton }}+{{ $t("labels.shift") }}+S
          </span>
        </button>

        <button
          v-if="!project.isReadOnly"
          type="button"
          :disabled="!canSaveAs"
          class="context-menu__entry ph-3"
          @click="saveAsSimulationGame()"
        >
          {{ $t("labels.saveAsGame") }}
        </button>
        <button
          v-if="
            canSaveAs &&
            (isForeignModel || license.limits.canDownload !== false)
          "
          type="button"
          class="context-menu__entry ph-3"
          @click="exportData()"
        >
          {{ $t("labels.export") }}
        </button>
      </context-menu>

      <!-- MODEL INFO -->
      <button
        type="button"
        class="button-icon button-icon_small ph-4 model-navbar__button"
        :title="$t('labels.modelInfo')"
        @click="toggleModelInfo"
      >
        <lucide-icon name="info" />
      </button>

      <!-- MENU-DROPDOWN -->
      <button
        ref="mainMenuButton"
        id="editor-mainmenu-button"
        class="button-icon button-icon_small ph-4 model-navbar__button"
        type="button"
        aria-haspopup="menu"
        aria-controls="editor-mainmenu"
        :aria-expanded="state.menuOpen"
        :aria-label="$t('labels.menu')"
        :title="$t('labels.menu')"
        :class="{ '-selected': state.menuOpen }"
        style="width: 3rem"
        @click="state.menuOpen = !state.menuOpen"
        @contextmenu.prevent="state.menuOpen = !state.menuOpen"
      >
        <lucide-icon :name="state.menuOpen ? 'x' : 'menu'" class="text-20" />
      </button>

      <context-menu
        v-if="state.menuOpen"
        id="editor-mainmenu"
        x-alignment="right"
        style="right: 1rem; top: calc(3.4rem - 5px)"
        transition="transition-fade"
        :non-closing-elements="mainMenuButton ? [mainMenuButton] : []"
        class="pv-2"
        @close="state.menuOpen = false"
      >
        <button
          type="button"
          :disabled="!permissions.canUpdate || loadedModel.isLocked"
          class="context-menu__entry ph-3"
          @click="save()"
        >
          {{ $t("actions.save") }}
          <span class="model-navbar__shortcut"> {{ cmdButton }}+S</span>
        </button>
        <button
          type="button"
          class="context-menu__entry ph-3"
          :disabled="!permissions.canFork"
          @click="saveAs()"
        >
          {{ $t("labels.saveAs") }}
          <span class="model-navbar__shortcut">
            {{ cmdButton }}+{{ $t("labels.shift") }}+S
          </span>
        </button>

        <button
          v-if="!project.isReadOnly"
          type="button"
          :disabled="!permissions.canFork"
          class="context-menu__entry ph-3"
          @click="saveAsSimulationGame()"
        >
          {{ $t("labels.saveAsGame") }}
        </button>
        <button
          v-if="
            permissions.canFork &&
            (isForeignModel || license.limits.canDownload !== false)
          "
          type="button"
          class="context-menu__entry ph-3"
          @click="exportData()"
        >
          {{ $t("labels.export") }}
        </button>

        <hr class="mv-1" />

        <button
          type="button"
          class="context-menu__entry ph-3"
          @click="openSettings()"
        >
          {{ $t("labels.settings") }}
        </button>
        <button
          type="button"
          class="context-menu__entry ph-3"
          @click="openLanguages()"
        >
          {{ $t("labels.languages") }}
        </button>
        <hr class="mv-1" />
        <button
          type="button"
          class="context-menu__entry ph-3"
          @click="openImprint()"
        >
          {{ $t("labels.imprint") }}
        </button>
        <a
          href="https://support.simcision.com"
          target="_blank"
          class="context-menu__entry ph-3"
        >
          {{ $t("links.supportPage") }} <lucide-icon name="external-link" class="model-navbar__shortcut" />
        </a>

        <template v-if="!loadedModel.embedded">
          <hr class="mv-1" />
          <button
            type="button"
            class="context-menu__entry ph-3"
            @click="close()"
          >
            {{ $t("labels.closeModel") }}
          </button>
        </template>
      </context-menu>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import * as SaveService from "@/api/SaveService";
import { useUnloadGuard } from "@/helpers/data/UnloadGuard";
import { showConfirm, showError } from "@core/ui/alert/alert";

import ContextMenu from "@core/ui/ContextMenu.vue";
import LucideIcon from "@core/ui/LucideIcon.vue";

import EditorNavigationModulesList from "@editor/components/EditorNavigationModulesList.vue";

import { useImprintPopup } from "@core/imprint/imprintPopup";
import { useLicense } from "@/api/license.store";
import { useLoadedModel } from "@editor/store/loadedModel.store";
import { useProjectStore } from "@editor/store/project.store";
import { useOverlay } from "@editor/ui/overlayDialog.store";
import { useSettingsPanel } from "@core/ui/settings.store";
import { useUndo } from "@editor/store/undo/undo.store";

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const undoStore = useUndo();

const mainMenuButton = ref<HTMLElement>();
const saveButton = ref<HTMLElement>();
const undoButton = ref<HTMLElement>();
const redoButton = ref<HTMLElement>();

const state = reactive({
  menuOpen: false
});
const license = useLicense();
const { loadedModel, getParentRoute } = useLoadedModel();

const project = useProjectStore();

const cmdButton = computed(() => {
  if (navigator.platform.toLowerCase().includes("mac")) {
    return t("labels.cmd");
  }
  return t("labels.ctrl");
});

// ========================
// UNDO AND REDO

const undoContextMenuOpen = ref(false);
const redoContextMenuOpen = ref(false);

const undoAvailableInOpenModule = computed(() => {
  const areaName = route.meta?.areaName as string | undefined;
  if (!areaName) return false;
  return !["simulation", "evaluation"].includes(areaName);
});

const canUndo = computed(() => {
  return undoStore.canUndo;
});
const canRedo = computed(() => {
  return undoStore.canRedo;
});

function undo() {
  undoStore.undo("model");
}
function redo() {
  undoStore.redo("model");
}

function undoAll() {
  undoStore.undoAll("model");
}
function redoAll() {
  undoStore.redoAll("model");
}

// ========================
// EXPORT

function exportData() {
  return SaveService.exportModel();
}

// ========================
// SAVE CONTEXT MENU

const saveContextMenuOpen = ref(false);

function onSaveContextmenu(event: MouseEvent) {
  event.preventDefault();
  saveContextMenuOpen.value = !saveContextMenuOpen.value;
}

// ========================
// SAVING / LOADING

const permissions = computed(() => {
  return loadedModel.permissions || {};
});
const isForeignModel = computed(() => {
  return loadedModel.type != "workspace_model";
});

const canSave = computed(() => {
  return permissions.value.canUpdate !== false && !loadedModel.isLocked;
});
const canSaveAs = computed(() => {
  return permissions.value.canFork !== false;
});

async function save() {
  if (!canSave.value == true) {
    return saveAs();
  }
  return SaveService.saveModel();
}

async function saveAs() {
  if (permissions.value.canFork === false) {
    if (loadedModel.type == "public_model") {
      showError(t("errors.publicModelNotForkable"));
    }
    return;
  }
  return SaveService.saveModel({ asNewModel: true });
}

async function saveAsSimulationGame() {
  if (!permissions.value.canFork || project.isReadOnly) return;
  return SaveService.saveModel({
    asNewModel: true,
    isSimulationGame: true
  });
}

// ========================
// TOGGLE MENU POPUPS

function toggleModelInfo() {
  const overlay = useOverlay();
  if (overlay.item?.type != "model") {
    return overlay.setItem({ type: "model" });
  } else {
    return overlay.hide();
  }
}

function openImprint() {
  return useImprintPopup().showImprint();
}

function openSettings() {
  useSettingsPanel().setSettingsPaneOpen(true);
}

function openLanguages() {
  useSettingsPanel().setLanguageSettingsOpen(true);
}

// ========================
// CLOSE MODEL

const { modelChanged } = useUnloadGuard();

async function close() {
  if (
    modelChanged.value == false ||
    (await showConfirm(
      t("questions.sureNoSave"),
      t("labels.closeModel"),
      t("labels.abort")
    ))
  ) {
    const route = getParentRoute(loadedModel);
    if ("electron" in window && window.electron) {
      window.electron.send("close");
    }
    router.push(route);
  }
}
</script>

<style lang="scss">
.model-navbar {
  contain: layout size;

  &__menu {
    min-width: 12rem;
  }

  &__button {
    height: 37px;
    font-size: 16px;
  }

  &__infoicon {
    font-size: 14px;
  }
  &__menuicon {
    font-size: 18px;
  }

  &__shortcut {
    font-size: 0.7em;
    opacity: 0.6;
    float: right;
    padding: 0.3em 0;
  }

  &__logocontainer {
    flex-shrink: 0;
    height: 2rem;
    display: flex;
    align-items: center;
    border-right: 1px solid var(--color-border);
    // display: none;
  }

  &__logo {
    position: relative;
    max-width: 100%;
    width: 7.8rem;
    height: 1.3rem;
    font-size: 1.5em;
    margin-top: 1px;
    margin-right: 1.5rem;
    fill: var(--color-grey-darker);
  }

  &__logocolor {
    fill: var(--color-grey-darker); // #888; // var(--color-action);
  }

  &__changemark {
    position: absolute;
    bottom: 0.6rem;
    right: 0.8rem;
    width: 0.5rem;
    height: 0.5rem;
    background-color: var(--color-action);
    border-radius: 50%;
    pointer-events: none;
  }
}
</style>
